import React from "react";
import {observer} from "mobx-react";
import {GameLoadingIndicatorRootBox} from "./boxes/game-loading-indicator-root.box";
import {ComponentServicesPick} from "../../../services/component-services-pick";
import {withServices} from "../../../react-hooks/with-services";

interface GameLoadingIndicatorComponentProps extends ComponentServicesPick<'gameRunner'> {

}

const ComponentBody: React.FC<GameLoadingIndicatorComponentProps> = observer((props) => {
    const loadingIndicator = props.gameRunner.gameLoadingIndicator;

    if(!loadingIndicator) {
        return null;
    }

    return (
        <GameLoadingIndicatorRootBox isHidden={loadingIndicator.isHidden} zIndex={props.gameRunner.gameFrameZIndex}>
            {loadingIndicator.render()}
        </GameLoadingIndicatorRootBox>
    );
})

export const GameLoadingIndicatorComponent = withServices(ComponentBody, ['gameRunner']);